/**
 * @generated SignedSource<<5b98d5059c430a6dfc3a74f4b2a20bce>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type InteriorsLandingModuleHeader_header$data = {
  readonly description: string | null;
  readonly title: string | null;
  readonly " $fragmentType": "InteriorsLandingModuleHeader_header";
};
export type InteriorsLandingModuleHeader_header$key = {
  readonly " $data"?: InteriorsLandingModuleHeader_header$data;
  readonly " $fragmentSpreads": FragmentRefs<"InteriorsLandingModuleHeader_header">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InteriorsLandingModuleHeader_header",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    }
  ],
  "type": "InteriorsLandingHeadModule",
  "abstractKey": null
};

(node as any).hash = "b430b0cde1eb4d891dac682d831e49eb";

export default node;
